<ng-container *ngIf="control">
  <mat-form-field appearance="outline">
    <mat-label>{{ inputData?.label }}</mat-label>
    <input matInput [matDatepicker]="picker" [formControl]="control" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <!-- Validation Error -->
  <app-validation-error
    [control]="control"
    [inputData]="inputData"></app-validation-error>
</ng-container>
